const BLOCKED_HTML_TAGS = new Set([
  'script',
  'iframe',
  'object',
  'embed',
  'meta',
  'base',
  'link',
  'style',
  'svg',
  'animate',
  'animatemotion',
  'animatetransform',
  'set',
  'img',
  'video',
  'audio',
  'source',
  'track',
  'form',
  'button',
  'input',
  'textarea',
  'select',
  'option',
  'label',
  'details',
  'summary',
  'fieldset',
  'legend',
]);

const DANGEROUS_STYLE_PATTERN = /@import|expression\s*\(|javascript:|vbscript:|url\s*\(|image-set\s*\(|-webkit-image-set\s*\(|image\s*\(/i;

function decodeCSSCodePoint(hex: string): string {
  const codePoint = parseInt(hex, 16);
  if (Number.isInteger(codePoint) && codePoint >= 0 && codePoint <= 0x10ffff) {
    return String.fromCodePoint(codePoint);
  }
  return '\uFFFD';
}

function normalizeCSSForInspection(value: string): string {
  return value
    .replace(/\/\*[\s\S]*?\*\//g, '')
    .replace(/\\([0-9a-fA-F]{1,6})\s?/g, (_, hex: string) => decodeCSSCodePoint(hex))
    .replace(/\\(.)/g, '$1');
}

function sanitizeTree(root: ParentNode): void {
  const elements = Array.from(root.querySelectorAll('*'));
  for (const element of elements) {
    if (element instanceof HTMLTemplateElement) {
      sanitizeTree(element.content);
    }
    const tag = element.tagName.toLowerCase();
    if (tag === 'style') {
      if (BLOCKED_HTML_TAGS.has(tag) || DANGEROUS_STYLE_PATTERN.test(normalizeCSSForInspection(element.textContent ?? ''))) {
        element.remove();
      }
      continue;
    }
    if (BLOCKED_HTML_TAGS.has(tag)) {
      element.remove();
      continue;
    }

    for (const attr of Array.from(element.attributes)) {
      const name = attr.name.toLowerCase();
      if (name.startsWith('on') || name === 'style' || name === 'srcdoc') {
        element.removeAttribute(attr.name);
        continue;
      }
      if (name === 'class' || name === 'id' || name === 'title' || name === 'role' || name.startsWith('aria-')) {
        continue;
      }
      element.removeAttribute(attr.name);
    }
  }
}

export function sanitizeRenderedHtml(markup: string): string {
  if (!markup) {
    return '';
  }
  const parser = new DOMParser();
  const doc = parser.parseFromString(markup, 'text/html');
  sanitizeTree(doc.body);
  return doc.body.innerHTML;
}
